/**
 * 只有“未认证”才强制回到登录页。
 *
 * 后端现在把三件事分开表达：
 *   401 = 未登录或令牌失效，需要重新登录
 *   403 = 已登录但被拒绝（缺少角色）
 *   409 = 已授权但平台前置条件不满足（例如隔离执行环境未启用）
 *
 * 把 403 也当成登录失效，会把用户从正在操作的页面直接踢到登录页，
 * 例如点击“验证环境并启用”时环境未准备好，本应就地显示错误。
 */
export function shouldForceLogout(status: number | undefined | null, pathname: string): boolean {
  // 嵌入页有自己的令牌与会话失效提示，不做整页跳转。
  if (pathname === '/embed/chat') return false
  return status === 401
}
